import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
export function SlideBenchmark() {
  const benchmarks = [{
    label: 'Engagement rate',
    minerva: 57,
    industry: 20,
    max: 60,
    suffix: '%',
    multiplier: '2.9×'
  }, {
    label: 'Click-to-capture conversion',
    minerva: 28,
    industry: 8,
    max: 30,
    suffix: '%',
    multiplier: '3.5×'
  }, {
    label: 'Avg engagement time',
    minerva: 4.3,
    industry: 1.5,
    max: 5,
    suffix: 'm',
    minervaDisplay: '4m 19s',
    industryDisplay: '~1m 30s',
    multiplier: '2.9×'
  }, {
    label: 'View-to-lead conversion',
    minerva: 16,
    industry: 5,
    max: 20,
    suffix: '%',
    multiplier: '3.2×'
  }];
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full" data-id="element-682">
      <div className="mb-8" data-id="element-683">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-684">
          Held against the industry, the result stands out
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-685">
          Compared with indicative benchmarks for interactive event activations,
          Minerva outperformed on every dimension that matters — turning a small
          footprint into outsized engagement and conversion.
        </p>
      </div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-686">
        {benchmarks.map((b, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2 + i * 0.12
      }} className="bg-white rounded-3xl p-7 border border-slate-100 shadow-sm flex flex-col" data-id="element-687">
            <div className="flex justify-between items-start mb-6" data-id="element-688">
              <h3 className="text-lg font-bold text-slate-800" data-id="element-689">{b.label}</h3>
              <div className="flex items-center gap-1.5 bg-minerva-blue/10 text-minerva-blue font-bold text-sm px-3 py-1.5 rounded-full shrink-0" data-id="element-690">
                <TrendingUp className="w-4 h-4" data-id="element-691" />
                {b.multiplier} industry avg
              </div>
            </div>

            <div className="space-y-4 flex-1 flex flex-col justify-center" data-id="element-692">
              {/* Minerva bar */}
              <div data-id="element-693">
                <div className="flex justify-between mb-1.5" data-id="element-694">
                  <span className="text-sm font-semibold text-minerva-dark" data-id="element-695">
                    Minerva
                  </span>
                  <span className="text-sm font-bold text-minerva-dark" data-id="element-696">
                    {b.minervaDisplay || `${b.minerva}${b.suffix}`}
                  </span>
                </div>
                <div className="h-5 bg-slate-100 rounded-full overflow-hidden" data-id="element-697">
                  <motion.div initial={{
                width: 0
              }} animate={{
                width: `${b.minerva / b.max * 100}%`
              }} transition={{
                duration: 1,
                delay: 0.4 + i * 0.12,
                ease: 'easeOut'
              }} className="h-full bg-minerva-blue rounded-full" data-id="element-698" />
                </div>
              </div>

              {/* Industry bar */}
              <div data-id="element-699">
                <div className="flex justify-between mb-1.5" data-id="element-700">
                  <span className="text-sm font-medium text-slate-400" data-id="element-701">
                    Industry benchmark
                  </span>
                  <span className="text-sm font-semibold text-slate-400" data-id="element-702">
                    {b.industryDisplay || `${b.industry}${b.suffix}`}
                  </span>
                </div>
                <div className="h-5 bg-slate-100 rounded-full overflow-hidden" data-id="element-703">
                  <motion.div initial={{
                width: 0
              }} animate={{
                width: `${b.industry / b.max * 100}%`
              }} transition={{
                duration: 1,
                delay: 0.55 + i * 0.12,
                ease: 'easeOut'
              }} className="h-full bg-slate-300 rounded-full" data-id="element-704" />
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2
    }} className="text-xs text-slate-400 mt-6 max-w-4xl" data-id="element-705">
        Industry benchmarks are indicative ranges drawn from interactive event
        and digital activation norms (engagement, dwell time, and lead
        conversion), shown for directional comparison rather than as a
        controlled study.
      </motion.p>
    </div>;
}